import React from 'react';
import { Search, CalendarDays, Users, BarChart3, Trophy, Gift } from 'lucide-react';
const bonuses = [{
  Icon: Search,
  number: 'Bonus 01',
  title: 'Quick Start Kit',
  desc: 'Start using Rugby 360 in 10 minutes. Activation guide, system structure and your first session ready for today.'
}, {
  Icon: CalendarDays,
  number: 'Bonus 02',
  title: 'Weekly Master Planner',
  desc: 'Organize your entire rugby week on a single sheet. Tracker, objectives and session wrap-up built in.'
}, {
  Icon: Users,
  number: 'Bonus 03',
  title: 'Express Corrections Bank',
  desc: 'What to correct, how to say it and when to step in without breaking the flow. Ready-to-use cues for the field.'
}, {
  Icon: BarChart3,
  number: 'Bonus 04',
  title: 'Post-Session Debrief Sheet',
  desc: 'Finish every session knowing what worked, what to fix and how to improve the next one, with simple field tests.'
}, {
  Icon: Trophy,
  number: 'Bonus 05',
  title: 'MVP Awards & Certificates',
  desc: 'Print-ready awards and certificates to recognise progress and keep your squad motivated all season.'
}, {
  Icon: Gift,
  number: 'Bonus 06',
  title: 'Rapid Adaptation Guide',
  desc: 'How to train well even when space, players or equipment are missing. The format can change. The objective cannot.'
}];
export function BonosSection() {
  return <section className="bg-ink px-5 py-14 md:py-24" data-id="element-21" data-mp="1akopuobp1oxf">
      <div className="max-w-6xl mx-auto" data-id="element-22" data-mp="1ekz56rldlroy">
        <div className="text-center mb-10 md:mb-14" data-id="element-23" data-mp="1ejp7w4mcknjd">
          <p className="text-[0.7rem] md:text-xs font-bold uppercase tracking-[0.16em] text-acid mb-3" data-id="element-24" data-mp="10tltu0xmg050">
            Included free today
          </p>
          <h2 className="font-display uppercase text-white text-[7vw] min-[430px]:text-3xl md:text-5xl leading-[1.05] mb-4" data-id="element-25" data-mp="15rdr7ah1cegl">
            Plus 6 strategic <span className="text-acid" data-id="element-26" data-mp="1y8zkvaupkuds">bonuses.</span>
          </h2>
          <p className="text-gray-300 text-sm md:text-lg max-w-xl mx-auto" data-id="element-27" data-mp="1yaap1bs2g45f">
            Included at no extra cost with the complete box set.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" data-id="element-28" data-mp="236wwbfn0t7ej">
          {bonuses.map(({
          Icon,
          number,
          title,
          desc
        }) => <article key={title} className="bg-panel border border-acid/15 p-5 md:p-7 flex flex-col" data-id="element-29" data-mp="1y8lotbk778zh">
              <div className="flex items-center justify-between mb-4 md:mb-6" data-id="element-30" data-mp="1p75nruf9wj7x">
                <span className="w-10 h-10 md:w-11 md:h-11 rounded-full bg-acid/15 text-acid flex items-center justify-center" data-id="element-31" data-mp="1keuc5ub678zj">
                  <Icon size={19} aria-hidden="true" data-id="element-32" data-mp="1fh2lf3m9hswx" />
                </span>
                <span className="text-[0.6rem] font-bold uppercase tracking-[0.16em] text-neon" data-id="element-33" data-mp="1ahpwmdbtybrp">
                  Free
                </span>
              </div>
              <div className="text-[0.65rem] font-bold uppercase tracking-[0.16em] text-gray-500 mb-1.5" data-id="element-34" data-mp="15jxwwx4y1lcy">
                {number}
              </div>
              <h3 className="font-display uppercase text-white text-lg md:text-xl leading-tight mb-2.5" data-id="element-35" data-mp="3d2tow67e0q3w">
                {title}
              </h3>
              <p className="text-gray-400 text-sm md:text-base leading-relaxed" data-id="element-36" data-mp="3h7b5xxmd4paz">
                {desc}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}